import { handleActions } from "redux-actions";

import {
    WHITEBOARD_ADD_CONTACT,
    WHITEBOARD_ADD_PERMISSION,
    WHITEBOARD_ADD_PERMISSION_COMPLETED,
    WHITEBOARD_CONTACTS_RESET,
    WHITEBOARD_PERMISSIONS_FETCH,
    WHITEBOARD_PERMISSIONS_FETCH_COMPLETED,
    WHITEBOARD_PERMISSIONS_FETCH_FAILURE,
    WHITEBOARD_REMOVE_CONTACT,
} from "constants/action-types";

interface IContact {
    __email: string;
    __name: string;
    __ref: string;
    _id: string;
}

interface IState {
    boardId: string | null;
    contacts: IContact[];
    hasMore: boolean;
    isAdding: boolean;
    isFetching: boolean;
    minIdentity?: string | null;
    result: string[];
}

const initialState: IState = {
    boardId: null,
    contacts: [],
    hasMore: false,
    isAdding: false,
    isFetching: false,
    minIdentity: null,
    result: [],
};

export const whiteboardPermissions = handleActions(
    {
        [WHITEBOARD_PERMISSIONS_FETCH]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [WHITEBOARD_PERMISSIONS_FETCH_COMPLETED]: (state: IState, { payload, error, meta }: any): IState => {
            if (error) {
                return {
                    ...state,
                    isFetching: false,
                };
            }
            return {
                ...state,
                hasMore: meta ? meta.hasMore : false,
                isFetching: false,
                minIdentity: meta.minIdentity,
                result: payload,
            };
        },
        [WHITEBOARD_ADD_PERMISSION]: (state: IState): IState => {
            return {
                ...state,
                isAdding: true,
            };
        },
        [WHITEBOARD_ADD_PERMISSION_COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return state;
            }
            return {
                ...state,
                result: payload,
            };
        },
        [WHITEBOARD_PERMISSIONS_FETCH_FAILURE]: (state: IState): IState => {
            return {
                ...state,
                isFetching: false,
            };
        },
        [WHITEBOARD_ADD_CONTACT]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                contacts: state.contacts.concat(payload),
            };
        },
        [WHITEBOARD_REMOVE_CONTACT]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                contacts: state.contacts.filter((contact) => contact.__ref !== payload.__ref),
            };
        },
        [WHITEBOARD_CONTACTS_RESET]: (state: IState): IState => {
            return {
                ...state,
                contacts: [],
                isAdding: false,
            };
        },
    },
    initialState
);
